import { CircleCheck } from 'lucide-react';

export function FormSuccess({ message }: { message?: string | null }) {
  if (!message) return null;

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md border border-emerald-500/40 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-700 dark:text-emerald-400"
    >
      <CircleCheck className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
